import { render, staticRenderFns } from "./homepage-nofooter.vue?vue&type=template&id=66489965&"
import script from "./homepage-nofooter.vue?vue&type=script&lang=js&"
export * from "./homepage-nofooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports